import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="120"
      height="120"
      fill="none"
      viewBox="0 0 120 120"
    >
      <path fill="url(#pattern0)" d="M0 0H120V120H0z" />
      <defs>
        <pattern
          id="pattern0"
          width="1"
          height="1"
          patternContentUnits="objectBoundingBox"
        >
          <use transform="scale(.00083)" xlinkHref="#image0" />
        </pattern>
        <image
          id="image0"
          width="1200"
          height="1200"
          xlinkHref="https://media.licdn.com/dms/image/sync/v2/D4D27AQEvmoe78kRy-Q/articleshare-shrink_800/articleshare-shrink_800/0/1737031302632?e=2147483647&v=beta&t=zCj6zR_x37kFNJWHYjYVC6IEZ4aPzVdazoL2-p4mY7Q"
        />
      </defs>
    </svg>
  );
}

export default Icon;
